module.exports = __webpack_public_path__ + "static/media/dtb.6ed0e2d9.png";